import moment from "moment";
import React from "react";
import { formatShortDate } from "utilities";

interface Props {
  birthdate: moment.Moment
}

const BirthdateRow = ({ birthdate }: Props) => {

  const yearsOld = moment.utc().diff(birthdate, "years");

  return <div>
    {formatShortDate(birthdate)} ({yearsOld} {RESX.Contact.YearsOld})
  </div>
};

export default BirthdateRow;